const getAssetPath = (resourse: string) => process.env.PUBLIC_URL + resourse;

export default getAssetPath;
